import clsx from 'clsx';
import React from 'react';

import { create_user_path, subscribe_path } from '../../routes';
import { getImgxSrc } from '../../utils/images';
import LockedLeadCaptureForm from '../shared/LockedLeadCaptureForm';
import styles from './styles.module.scss';

const Logos = [
  'Bain.png',
  'Spotify.png',
  'Goldman.png',
  'Upenn.png',
  'Meta.png',
  'Morgan.png',
  'Amazon.png',
  'Netflix.png',
  'Google.png',
  'Accenture.png',
  'Uber.png',
  'Stanford.png',
  'Columbia.png',
  'Harvard.png',
  'Microsoft.png',
];

const LayOut = ({ gdpr }: { gdpr: boolean }) => {
  return (
    <div className="container org-signup">
      <div className={clsx(styles.emailContainer, 'row')}>
        <div className={clsx(styles.emailWrapper, 'col-sm-12 col-md-6')}>
          <div className={clsx(styles.topRibbon)} />
          <div className={styles.header}>Sign up via your school or company</div>
          <div className={styles.subheader}>Your organization email</div>
          <LockedLeadCaptureForm
            buttonText="Validate Email"
            endpointUri={create_user_path()}
            leadType="org_email_domain"
            redirectUri={subscribe_path()}
            isGdprLead={gdpr}
          />
        </div>
      </div>
      <div className={clsx(styles.logosContainer)}>
        {Logos.map((imgPath) => (
          <div key={imgPath} className={styles.imageContainer}>
            <img
              className={styles.image}
              src={getImgxSrc(`logo-image-url/${imgPath}`)}
              alt={`${imgPath.replace('.png', '')} icon`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LayOut;
